import { useEffect } from 'react';
import { createFileRoute, Outlet } from '@tanstack/react-router';
import { useSpaceCheckinMutation } from '@onesource/services';
import { SubNavPageContainer } from '../../../../../components/page-container';

export const Route = createFileRoute('/_protected/community-hub/spaces/$id')({
  component: SpaceRouteWrapper,
});

function SpaceRouteWrapper() {
  const { id } = Route.useParams();
  const { mutate: checkin } = useSpaceCheckinMutation();

  useEffect(() => {
    checkin(id);
  }, [id]);

  return (
    <SubNavPageContainer>
      <Outlet />
    </SubNavPageContainer>
  );
}
